module.exports = __webpack_public_path__ + "static/media/samplebulkvehicleavailability.8279e2e3.xlsx";